import { render, staticRenderFns } from "./VendingModal.vue?vue&type=template&id=38ea3960"
import script from "./VendingModal.vue?vue&type=script&lang=js"
export * from "./VendingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports